/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfCreateOrEditVehicleSaleDto } from "../models/AjaxResponseOfCreateOrEditVehicleSaleDto";
import type { AjaxResponseOfGuid } from "../models/AjaxResponseOfGuid";
import type { CreateOrEditVehicleSaleDto } from "../models/CreateOrEditVehicleSaleDto";
import type { UndoVehicleSaleDto } from "../models/UndoVehicleSaleDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class VehicleSaleAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfCreateOrEditVehicleSaleDto
   * @throws ApiError
   */
  public getById({
    vehicleId,
  }: {
    vehicleId: string;
  }): CancelablePromise<AjaxResponseOfCreateOrEditVehicleSaleDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-sale/{vehicleId}",
      path: {
        vehicleId: vehicleId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGuid
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: CreateOrEditVehicleSaleDto;
  }): CancelablePromise<AjaxResponseOfGuid> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-sale",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public update({
    requestBody,
  }: {
    requestBody?: CreateOrEditVehicleSaleDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/vehicle-sale",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public undoVehicleSale({
    vehicleSaleId,
    requestBody,
  }: {
    vehicleSaleId: string;
    requestBody?: UndoVehicleSaleDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-sale/{vehicleSaleId}",
      path: {
        vehicleSaleId: vehicleSaleId,
      },
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
}
